var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticStyle:{"display":"inline-flex"}},[_c('div',{staticClass:"iconfont icon-sy-loading rotate",class:_vm.styleClass,style:(_vm.styleObject)}),_vm._v(" "),(_vm.text !== null || _vm.text !== '')?_c('div',{staticClass:"text",style:(("--height: " + (_vm.styleObject.fontSize)))},[_vm._v(_vm._s(_vm.text))]):_vm._e()])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7072057a","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/commons/Loading.vue
// module id = null
// module chunks = 